import { useState } from 'react';
import api from '@/lib/api';
import { useWebSocket } from '@/context/WebSocketContext';
import { canUsePush } from '@/lib/alarm';
import { Button } from '@/components/ui/button';
import { BellRing, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export function TestPushButton({ className = '', size = 'default', testId = 'test-push-btn', onSuccess }) {
  const { pushEnabled, enablePush } = useWebSocket();
  const [sending, setSending] = useState(false);

  const handleClick = async () => {
    if (!canUsePush()) {
      const ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
      toast.error(ios
        ? 'Öppna Vapelarm från hemskärmsikonen för att använda pushnotiser.'
        : 'Den här webbläsaren stöder inte pushnotiser.');
      return;
    }
    setSending(true);
    try {
      if (!pushEnabled && !(await enablePush())) {
        toast.error('Pushnotiser är inte tillåtna. Kontrollera telefonens notisinställningar.');
        return;
      }
      const res = await api.post('/push/test-self', {});
      if (res.data.success) {
        toast.success('Testnotis skickad! Den bör visas på din telefon inom några sekunder.');
        onSuccess?.();
      } else {
        toast.error(`Testnotisen kunde inte levereras (${res.data.error}). Aktivera pushnotiser igen.`);
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Kunde inte skicka testnotis');
    } finally {
      setSending(false);
    }
  };

  return (
    <Button onClick={handleClick} disabled={sending} size={size} className={`gap-2 bg-navy hover:bg-navy/90 font-ibm ${className}`} data-testid={testId}>
      {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4" />}
      Skicka testnotis till min telefon
    </Button>
  );
}
